'use strict';

import router from '../../router';

// initial state
const state = {
};

// mutations
const mutations = {
};

// getters
const getters = {
};

// actions
const actions = {
    openList() {
        router.push({
            name: 'list'
        });
    },
    openTable() {
        router.push({
            name: 'table'
        });
    },
    openCatalog() {
        router.push({
            name: 'catalog'
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js